import React from 'react';
import { Icon } from 'semantic-ui-react';
import { maskMoney } from '../../../../../../../../services/masks';
import * as S from './styles';

// Detalhes das assistências
const ASSISTANCE_DETAILS: Record<string, { name: string }> = {
  Basic: { name: 'Assistência Plena' },
  Essential: { name: 'Assistência Especial' },
  Complete: { name: 'Assistência Top' },
};

export type PriceSummaryProps = {
  selectedPlan?: {
    nomeSeguro: string;
    valorParcela: number;
    premioTotal: number;
    quantidadeParcela: number;
  };
  selectedAssistance?: {
    id: string;
    grossAmount: number;
  };
  validity: number;
};

const PriceSummary = ({
  selectedPlan,
  selectedAssistance,
  validity,
}: PriceSummaryProps) => {
  if (!selectedPlan) return null;

  const assistanceDetails = selectedAssistance
    ? ASSISTANCE_DETAILS[selectedAssistance.id]
    : null;

  const assistanceMonthly = selectedAssistance
    ? selectedAssistance.grossAmount / validity
    : 0;

  const assistanceIsFree = assistanceMonthly === 0;

  // Cálculos
  const planMonthly = selectedPlan.valorParcela;
  const totalMonthly = planMonthly + assistanceMonthly;

  const planTotal = selectedPlan.premioTotal;
  const assistanceTotal = selectedAssistance?.grossAmount || 0;
  const totalPremium = planTotal + assistanceTotal;

  return (
    <S.Wrapper>
      <S.Title>
        <Icon name="calculator" />
        Resumo do Valor a Contratar
      </S.Title>

      {/* Detalhamento do Plano */}
      <S.Row>
        <S.Label>
          Plano: <strong>{selectedPlan.nomeSeguro}</strong>
        </S.Label>
        <S.Value>R$ {maskMoney(String(planMonthly), true)}/mês</S.Value>
      </S.Row>

      {/* Detalhamento da Assistência */}
      <S.Row>
        <S.Label>
          Assistência: <strong>{assistanceDetails?.name || 'Não selecionada'}</strong>
          {assistanceDetails && (
            <S.AssistanceBadge isFree={assistanceIsFree}>
              {assistanceIsFree ? 'Incluso' : `+ R$ ${maskMoney(String(assistanceMonthly), true)}`}
            </S.AssistanceBadge>
          )}
        </S.Label>
        <S.Value>
          {assistanceIsFree ? 'Incluso' : `R$ ${maskMoney(String(assistanceMonthly), true)}/mês`}
        </S.Value>
      </S.Row>

      {/* Total da Parcela */}
      <S.TotalRow>
        <S.TotalLabel>Valor da Parcela:</S.TotalLabel>
        <S.TotalValue>
          {selectedPlan.quantidadeParcela}x R$ {maskMoney(String(totalMonthly), true)}
        </S.TotalValue>
      </S.TotalRow>

      {/* Informações de Prêmio Total */}
      <S.PremiumInfo>
        <S.PremiumRow>
          <S.PremiumLabel>Prêmio do Plano:</S.PremiumLabel>
          <S.PremiumValue>R$ {maskMoney(String(planTotal), true)}</S.PremiumValue>
        </S.PremiumRow>
        {!assistanceIsFree && assistanceTotal > 0 && (
          <S.PremiumRow>
            <S.PremiumLabel>Prêmio da Assistência:</S.PremiumLabel>
            <S.PremiumValue>R$ {maskMoney(String(assistanceTotal), true)}</S.PremiumValue>
          </S.PremiumRow>
        )}
        <S.PremiumRow>
          <S.PremiumLabel>Prêmio Total:</S.PremiumLabel>
          <S.PremiumTotal>R$ {maskMoney(String(totalPremium), true)}</S.PremiumTotal>
        </S.PremiumRow>
      </S.PremiumInfo>
    </S.Wrapper>
  );
};

export default PriceSummary;


